import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { ActionIcon, Collapse, Menu, TextInput, Tooltip } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { MRT_FilterOptionMenu } from '../menus/MRT_FilterOptionMenu';
export const MRT_GlobalFilterTextInput = ({ table, }) => {
    const { getState, setGlobalFilter, options: { enableGlobalFilterModes, icons: { IconSearch, IconX }, localization, manualFiltering, mantineSearchTextInputProps, }, refs: { searchInputRef }, } = table;
    const { globalFilter, showGlobalFilter } = getState();
    const textFieldProps = mantineSearchTextInputProps instanceof Function
        ? mantineSearchTextInputProps({ table })
        : mantineSearchTextInputProps;
    const isMounted = useRef(false);
    const [searchValue, setSearchValue] = useState(globalFilter !== null && globalFilter !== void 0 ? globalFilter : '');
    const [debouncedSearchValue] = useDebouncedValue(searchValue, manualFiltering ? 500 : 250);
    useEffect(() => {
        setGlobalFilter(debouncedSearchValue || undefined);
    }, [debouncedSearchValue]);
    const handleClear = () => {
        setSearchValue('');
        setGlobalFilter(undefined);
    };
    useEffect(() => {
        if (isMounted.current) {
            if (globalFilter === undefined) {
                handleClear();
            }
            else {
                setSearchValue(globalFilter);
            }
        }
        isMounted.current = true;
    }, [globalFilter]);
    return (_jsxs(Collapse, { in: showGlobalFilter, sx: {
            '& > div': {
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                flexWrap: 'nowrap',
            },
        }, children: [enableGlobalFilterModes && (_jsxs(Menu, { withinPortal: true, children: [_jsx(Menu.Target, { children: _jsx(ActionIcon, { "aria-label": localization.changeSearchMode, size: "sm", children: _jsx(IconSearch, {}) }) }), _jsx(MRT_FilterOptionMenu, { table: table, onSelect: handleClear })] })), _jsx(TextInput, Object.assign({ placeholder: localization.search, onChange: (event) => setSearchValue(event.target.value), value: searchValue !== null && searchValue !== void 0 ? searchValue : '', variant: "filled", icon: !enableGlobalFilterModes && _jsx(IconSearch, {}), rightSection: searchValue ? (_jsx(ActionIcon, { "aria-label": localization.clearSearch, disabled: !(searchValue === null || searchValue === void 0 ? void 0 : searchValue.length), onClick: handleClear, size: "sm", children: _jsx(Tooltip, { withinPortal: true, label: localization.clearSearch, children: _jsx(IconX, {}) }) })) : null }, textFieldProps, { ref: (node) => {
                    if (node) {
                        searchInputRef.current = node;
                        if (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.ref) {
                            // @ts-ignore
                            textFieldProps.ref = node;
                        }
                    }
                }, sx: (theme) => (Object.assign({ minWidth: '250px' }, ((textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.sx) instanceof Function
                    ? textFieldProps.sx(theme)
                    : textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.sx))) }))] }));
};
//# sourceMappingURL=MRT_GlobalFilterTextInput.js.map